// Штаб цикла (вкладка hq): карточка персонажа, личные сведения,
// директория разделов. Вынесено из CycleTab.tsx без изменения
// поведения (Фаза 1).

import { useState } from "react";
import { CommandHubModal, type CommandHubModalKind } from "./SituationSection";
import {
  Avatar,
  GAME_UI_ASSET_BASE,
  OwnerForcePhaseControl,
  compactText,
  type Props,
  type Section,
} from "./shared";

function HqSection({
  campaignId,
  setup,
  action,
  onNavigate,
  onOpenTab,
}: Props & { onNavigate: (section: Section) => void }) {
  const cycle = setup.cycle.current!;
  const hub = setup.commandHub;
  const [openModal, setOpenModal] = useState<CommandHubModalKind | null>(null);
  if (!hub) {
    return (
      <div className="cc-hq-home-shell">
        <section className="cc-world-panel">
          <h2>Штаб</h2>
          <p>Служебные разделы кампании.</p>
        </section>
      </div>
    );
  }
  return (
    <div className="cc-hq-home-shell" aria-label="Штаб кампании">
      <section className="cc-hq-character-card cc-hq-character-card-enhanced">
        <button type="button" onClick={() => setOpenModal("dossier")}>
          <Avatar campaignId={campaignId} memberId={hub.character.campaignMemberId} name={hub.character.displayName} avatar={hub.character.avatar} />
          <span className="cc-hq-character-copy">
            <small>Персонаж</small>
            <strong>{hub.character.displayName}</strong>
            <em>{hub.character.title}{hub.character.genderLabel ? ` · ${hub.character.genderLabel}` : ""}</em>
            <p>{compactText(hub.character.dutiesShort, 112)}</p>
            {hub.character.specialPowerShort && <u>Особое: {compactText(hub.character.specialPowerShort, 82)}</u>}
          </span>
          <i>›</i>
        </button>
      </section>

      {hub.personalIntel && (
        <button type="button" className="cc-world-panel cc-hq-intel-card" onClick={() => setOpenModal("intel")}>
          <div className="cc-world-panel-title"><img src={`${GAME_UI_ASSET_BASE}/icon_dossier.png`} alt="" /><h3>{hub.personalIntel.title}</h3></div>
          <p>{hub.personalIntel.shortText}</p>
        </button>
      )}

      <section className="cc-world-panel cc-hq-directory-panel">
        <div className="cc-world-panel-title"><img src={`${GAME_UI_ASSET_BASE}/icon_room_council.png`} alt="" /><h3>Разделы штаба</h3></div>
        <div className="cc-hq-directory-grid">
          <HqDirectoryButton icon="icon_room_council.png" title="Совет" subtitle="состав и политическая среда" onClick={() => onOpenTab?.("council")} />
          <HqDirectoryButton icon="icon_room_world.png" title="Справочник мира" subtitle="институты, фракции и устройство города" onClick={() => onOpenTab?.("world")} />
          <HqDirectoryButton icon="icon_dossier.png" title="Полное досье" subtitle="карточка персонажа и скрытые сведения" onClick={() => setOpenModal("dossier")} />
        </div>
      </section>

      {openModal && (
        <CommandHubModal
          kind={openModal}
          hub={hub}
          campaignId={campaignId}
          setup={setup}
          cycle={cycle}
          action={action}
          onClose={() => setOpenModal(null)}
        />
      )}
      <OwnerForcePhaseControl campaignId={campaignId} setup={setup} action={action} />
    </div>
  );
}
function HqDirectoryButton({
  icon,
  title,
  subtitle,
  badge,
  onClick,
}: {
  icon: string;
  title: string;
  subtitle: string;
  badge?: string;
  onClick?: () => void;
}) {
  return (
    <button type="button" className="cc-hq-directory-button" onClick={onClick}>
      <img src={`${GAME_UI_ASSET_BASE}/${icon}`} alt="" />
      <span><strong>{title}</strong><small>{subtitle}</small></span>
      {badge && <b>{badge}</b>}
      <i>›</i>
    </button>
  );
}

export {
  HqSection,
  HqDirectoryButton,
};
